import React from 'react'

const SvgAbdomenOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M12.91 16.5c0 .497-.407.9-.91.9a.905.905 0 01-.908-.9c0-.497.407-.9.909-.9s.909.403.909.9z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.273 3a20.317 20.317 0 00-.234 1.8c-.167 1.986-.016 3.816.29 5.809.164.948.507 2.91.556 3.172l.062.329c.284 1.514.596 3.179.887 5.09.088.577.175 1.176.258 1.8H2.91c.086-.623.178-1.222.272-1.8.261-1.595.548-3.03.816-4.374l.204-1.03c.16-.87.499-2.728.563-3.203.268-1.877.384-3.725.196-5.793-.052-.58-.129-1.179-.233-1.8h14.545zm-2.058 1.8c-.165 2.14.009 4.097.328 6.16l.556 3.163.077.407c.265 1.41.548 2.919.82 4.67H5.024c.239-1.43.492-2.693.736-3.913l.23-1.153c.147-.763.466-2.473.564-3.211C6.837 8.965 6.97 7 6.786 4.8h10.43z'
    />
  </svg>
)

export default SvgAbdomenOutline
